import * as React from "react";
import {EmployeeSalaryInfoData} from "../../models/employee-salary-info-data";
import styled from "styled-components";

interface SalaryCalculatorFormCalculatorDataPresentationProps {
  employeeSalaryInfoData: EmployeeSalaryInfoData
}

interface SalaryCalculatorFormCalculatorDataPresentationState {}

class SalaryCalculatorFormCalculatorDataPresentation extends React.Component<SalaryCalculatorFormCalculatorDataPresentationProps, SalaryCalculatorFormCalculatorDataPresentationState> {

    constructor(props: SalaryCalculatorFormCalculatorDataPresentationProps) {
        super(props);
    }

    renderTableTitle(tableTitle: string) {
        return (
            <TableNameWrapper>
                {tableTitle}
            </TableNameWrapper>
        )
    }

    renderHeaderRow(lit: string, name: string, value: string) {
        return (
            <Tr>
                <Th style={{width:"50px"}}>{lit}</Th>
                <Th>{name}</Th>
                <Th style={{width:"150px"}}>{value}</Th>
            </Tr>
        );
    }

    renderRow(lit: string, name: string, value: number, nameInfo?: string) {
        return (
            <Tr>
                <Td style={{textAlign: "center"}}>{lit}</Td>
                <Td>
                    {name}
                    {nameInfo && <span style={{fontSize: "12px"}}>{nameInfo}</span>}
                </Td>
                <Td style={{textAlign: "right"}}>{value.toFixed(2)}</Td>
            </Tr>
        );
    }

    renderSummaryRow(name: string, value: number) {
        return (
            <Tr>
                <Td colSpan="2" style={{textAlign: "center"}}>{name}</Td>
                <Td style={{textAlign: "right"}}>{value.toFixed(2)}</Td>
            </Tr>
        )
    }

    render() {
        // DANE UNIWERSALNE
        const {
            employeeTaxInfoData,
            employeeTaxInfoSummaryData,
            employeeZUSInfoData,
            employeeZusInfoSummaryData
        } = this.props.employeeSalaryInfoData;

        // ZMIENNE
        const totalNonZusCost: number = employeeTaxInfoSummaryData.totalEmployeeTaxCost - employeeTaxInfoData.incomeDeducibleSocialSecurityContributions;
        const zusExist: boolean = Boolean(employeeZUSInfoData) && Boolean(employeeZusInfoSummaryData);
        const totalZus: number = zusExist ? employeeZusInfoSummaryData.totalEmployeeZus + employeeZusInfoSummaryData.totalEmployerZus : 0;
        const totalPPK: number = zusExist ? employeeZusInfoSummaryData.totalEmployeePPK + employeeZusInfoSummaryData.totalEmployerPPK : 0;
        const employerZus: number = zusExist ? employeeZusInfoSummaryData.totalEmployerZus : 0;
        const employerPPK: number = zusExist ? employeeZusInfoSummaryData.totalEmployerPPK : 0;
        const totalEmployerSalaryCost: number = employeeTaxInfoSummaryData.totalEmployeeIncome + employerZus + employerPPK;
        const totalEmploymentNonSalaryCost: number = totalEmployerSalaryCost - employeeTaxInfoSummaryData.totalEmployeeNetSalary;

        return (
            <div>
                {this.renderTableTitle('PODSUMOWANIE DANYCH O WYNAGRODZENIU')}
                <Table>
                    <Thead>
                        {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                    </Thead>
                    <Tbody>
                        {/* A */}
                        {this.renderRow('A','WYNAGRODZENIE NETTO',employeeTaxInfoSummaryData.totalEmployeeNetSalary)}
                        {this.renderRow('A.1','WYNAGRODZENIE BRUTTO',employeeTaxInfoSummaryData.totalEmployeeIncome)}
                        {this.renderRow('A.2','KOSZTY UZYSKANIA PRZYCHODU',employeeTaxInfoSummaryData.totalEmployeeTaxCost)}
                        {this.renderRow('A.2.1','KOSZT UZYSKANIA PRZYCHODU - SKŁADKI ZUS: [B.1 + B.2 + B.3]',employeeTaxInfoData.incomeDeducibleSocialSecurityContributions)}
                        {this.renderRow('A.2.2','KOSZT UZYSKANIA PRZYCHODU - INNE ZWIĄZANE Z FORMĄ ZATRUDNIA',totalNonZusCost)}
                        {this.renderRow('A.3','SKŁADKA ZDROWOTNA',employeeTaxInfoData.totalHealthInsuranceContributions)}
                        {this.renderRow('A.4','DOCHÓD OPODATKOWANY: [A.1 - A.2]',employeeTaxInfoSummaryData.totalEmployeeTaxProfit)}
                        {this.renderRow('A.5','PODATEK DOCHODOWY',employeeTaxInfoSummaryData.totalEmployeeTaxAdvance)}
                        {this.renderSummaryRow('SPOSÓB LICZENIA: A.1 - A.2 - A.3 - A.5',employeeTaxInfoSummaryData.totalEmployeeNetSalary)}
                    </Tbody>
                </Table>

                {zusExist && this.renderTableTitle('PODSUMOWANIE DANYCH: SKŁADKI ZUS UBEZPIECZONEGO')}
                {zusExist &&
                    <Table>
                        <Thead>
                            {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                        </Thead>
                        <Tbody>
                            {/* ZUS B */}
                            {this.renderRow('B','SKŁADKI ZUS UBEZPIECZONEGO',employeeZusInfoSummaryData.totalEmployeeZus)}
                            {this.renderRow('B.1','SKŁADKA EMERYTALNA',employeeZUSInfoData.socialSecurityRetirementPayedByEmployee, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityRetirementAndDisabilityBase.toFixed(2)}`)}
                            {this.renderRow('B.2','SKŁADKA RENTOWA',employeeZUSInfoData.socialSecurityDisabilityPayedByEmployee, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityRetirementAndDisabilityBase.toFixed(2)}`)}
                            {this.renderRow('B.3','SKŁADKA CHOROBOWA',employeeZUSInfoData.socialSecurityIllnessPayedByEmployee, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityIllnessBase.toFixed(2)}`)}
                            {this.renderRow('B.4','SKŁADKA WYPADKOWA',employeeZUSInfoData.socialSecurityAccidentPayedByEmployee)}
                            {this.renderRow('B.5','SKŁADKA ZDROWOTNA',employeeZUSInfoData.socialSecurityHealthPayedByEmployee, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityHealthBase.toFixed(2)}`)}
                            {this.renderSummaryRow('SPOSÓB LICZENIA: B.1 + B.2 + B.3 + B.4 + B.5',employeeZusInfoSummaryData.totalEmployeeZus)}
                        </Tbody>
                    </Table>
                }

                {zusExist && this.renderTableTitle('PODSUMOWANIE DANYCH: SKŁADKI ZUS PŁATNIKA')}
                {zusExist &&
                    <Table>
                        <Thead>
                            {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                        </Thead>
                        <Tbody>
                            {/* ZUS C */}
                            {this.renderRow('C','SKŁADKI ZUS PŁATNIKA',employeeZusInfoSummaryData.totalEmployerZus)}
                            {this.renderRow('C.1','SKŁADKA EMERYTALNA',employeeZUSInfoData.socialSecurityRetirementPayedByEmployer, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityRetirementAndDisabilityBase.toFixed(2)}`)}
                            {this.renderRow('C.2','SKŁADKA RENTOWA',employeeZUSInfoData.socialSecurityDisabilityPayedByEmployer, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityRetirementAndDisabilityBase.toFixed(2)}`)}
                            {this.renderRow('C.3','SKŁADKA CHOROBOWA',employeeZUSInfoData.socialSecurityIllnessPayedByEmployer)}
                            {this.renderRow('C.4','SKŁADKA WYPADKOWA',employeeZUSInfoData.socialSecurityAccidentPayedByEmployer, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityAccidentBase.toFixed(2)}`)}
                            {this.renderRow('C.5','SKŁADKA ZDROWOTNA',employeeZUSInfoData.socialSecurityHealthPayedByEmployer)}
                            {this.renderRow('C.6','SKŁADKA NA FUNDUSZ PRACY',employeeZUSInfoData.socialSecurityLabourFundPayedByEmployer, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityRetirementAndDisabilityBase.toFixed(2)}`)}
                            {this.renderRow('C.7','SKŁADKA NA FGŚP',employeeZUSInfoData.socialSecurityEmployeeBenefitsPayedByEmployer, `PODSTAWA WYMIARU: ${employeeZUSInfoData.socialSecurityRetirementAndDisabilityBase.toFixed(2)}`)}
                            {this.renderSummaryRow('SPOSÓB LICZENIA: C.1 + C.2 + C.3 + C.4 + C.5 + C.6 + C.7',employeeZusInfoSummaryData.totalEmployerZus)}
                        </Tbody>
                    </Table>
                }

                {zusExist && this.renderTableTitle('PODSUMOWANIE DANYCH: RAZEM SKŁADKI ZUS')}
                {zusExist &&
                    <Table>
                        <Thead>
                            {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                        </Thead>
                        <Tbody>
                            {/* ZUS D */}
                            {this.renderRow('D','RAZEM SKŁADKI ZUS',totalZus)}
                            {this.renderRow('D.1','SKŁADKI ZUS UBEZPIECZONEGO',employeeZusInfoSummaryData.totalEmployeeZus)}
                            {this.renderRow('D.2','SKŁADKI ZUS PŁATNIKA',employeeZusInfoSummaryData.totalEmployerZus)}
                            {this.renderSummaryRow('SPOSÓB LICZENIA: D.1 + D.2',totalZus)}
                        </Tbody>
                    </Table>
                }

                {zusExist && this.renderTableTitle('PODSUMOWANIE DANYCH: RAZEM PPK')}
                {zusExist &&
                    <Table>
                        <Thead>
                            {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                        </Thead>
                        <Tbody>
                            {/* PPK E */}
                            {this.renderRow('E','RAZEM PPK',totalPPK)}
                            {this.renderRow('E.1','PPK PODSTAWOWA - UBEZPIECZONY',employeeZUSInfoData.socialSecurityBasePPKPayedByEmployee)}
                            {this.renderRow('E.2','PPK PODSTAWOWA - PŁATNIK',employeeZUSInfoData.socialSecurityBasePPKPayedByEmployer)}
                            {this.renderRow('E.3','PPK DODATKOWA - UBEZPIECZONY',employeeZUSInfoData.socialSecurityAdditionalPPKPayedByEmployee)}
                            {this.renderRow('E.4','PPK DODATKOWA - PŁATNIK',employeeZUSInfoData.socialSecurityAdditionalPPKPayedByEmployee)}
                            {this.renderSummaryRow('SPOSÓB LICZENIA: E.1 + E.2 + E.3 + E.4',totalPPK)}
                        </Tbody>
                    </Table>
                }

                {this.renderTableTitle('PODSUMOWANIE DANYCH: ŁĄCZNY KOSZT WYNAGRODZENIA DLA PŁATNIKA')}
                <Table>
                    <Thead>
                        {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                    </Thead>
                    <Tbody>
                        {/* SALARY COST F */}
                        {this.renderRow('F','ŁĄCZNY KOSZT WYNAGRODZENIA',totalEmployerSalaryCost)}
                        {this.renderRow('F.1','WYNAGRODZNIE BRUTTO',employeeTaxInfoSummaryData.totalEmployeeIncome)}
                        {zusExist && this.renderRow('F.2','SKŁADKI ZUS  - CZĘŚĆ PŁATNIKA',employeeZusInfoSummaryData.totalEmployerZus)}
                        {zusExist && this.renderRow('F.3','PPK - CZĘŚĆ PŁATNIKA',employeeZusInfoSummaryData.totalEmployerPPK)}
                        {!zusExist && this.renderSummaryRow('SPOSÓB LICZENIA: F.1',totalEmployerSalaryCost)}
                        {zusExist && this.renderSummaryRow('SPOSÓB LICZENIA: F.1 + F.2 + F.3',totalEmployerSalaryCost)}
                    </Tbody>
                </Table>

                {this.renderTableTitle('PODSUMOWANIE DANYCH: OBCIĄŻENIA PUBLICZNO-PRAWNE')}
                <Table>
                    <Thead>
                        {this.renderHeaderRow('LIT','NAZWA POZYCJI','WARTOŚĆ')}
                    </Thead>
                    <Tbody>
                        {/* EFEKTYWNE OPODATKOWANIE G */}
                        {
                            this.renderRow(
                                'G',
                                'ŁĄCZNE OBCIĄŻENIA PUBLICZNO-PRAWNE',
                                totalEmploymentNonSalaryCost,
                                `${totalEmploymentNonSalaryCost} z ${totalEmployerSalaryCost} = ${getPercent(totalEmploymentNonSalaryCost, totalEmployerSalaryCost)}%`
                            )
                        }
                        {
                            this.renderRow(
                                'G.1',
                                'PODATEK DOCHODOWY',
                                employeeTaxInfoSummaryData.totalEmployeeTaxAdvance,
                                `${employeeTaxInfoSummaryData.totalEmployeeTaxAdvance} z ${totalEmployerSalaryCost} = ${getPercent(employeeTaxInfoSummaryData.totalEmployeeTaxAdvance, totalEmployerSalaryCost)}%`
                            )
                        }
                        {zusExist &&
                            this.renderRow(
                                'G.2',
                                'SKŁADKI ZUS - ŁĄCZNIE',
                                totalZus,
                                `${totalZus} z ${totalEmployerSalaryCost} = ${getPercent(totalZus, totalEmployerSalaryCost)}%`
                            )
                        }
                        {zusExist &&
                            this.renderRow(
                                'G.3',
                                'PPK - ŁĄCZNIE',
                                totalPPK,
                                `${totalPPK} z ${totalEmployerSalaryCost} = ${getPercent(totalPPK, totalEmployerSalaryCost)}%`
                            )
                        }
                    </Tbody>
                </Table>
            </div>
        );
    }

}

function getPercent(value: number, total: number): string {
    return `${(value / total * 100).toFixed(2)}`;
}

/** STYLES */

const TableNameWrapper = styled.div`
    text-align: left;
    margin-top: 10px;
    text-decoration: underline;
    color: #000;
    font-weight: bold;
    font-size: 16px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
`;

const Th = styled.th`
    border: 1px solid #ddd;
    padding: 10px;
    background-color: #f9f9f9;
    text-align: center;
`;

const Td = styled.td`
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    span {
        display: block;
    }
`;

const Tr = styled.tr`
    &:nth-child(even) {
        background-color: #f2f2f2;
    }
`;

const Thead = styled.thead`
    font-weight: bold;
`;

const Tbody = styled.tbody``;

export default SalaryCalculatorFormCalculatorDataPresentation



// WEBPACK FOOTER //
// ./src/layouts/salary-calculator-form-block/salary-calculator-form-calculator-data-presentation.tsx